import Modal from "react-modal";
import { X, Trash2, Loader } from "lucide-react";

const DeleteUserModal = ({
  isOpen,
  onClose,
  onConfirm,
  userName,
  isDeleting,
}) => {
  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onClose}
      ariaHideApp={false}
      overlayClassName="fixed inset-0 bg-black/50 flex items-center justify-center z-50"
      className="bg-white animate-scale-in rounded-2xl shadow-xl max-w-md w-full p-6 relative outline-none"
      shouldCloseOnOverlayClick={true}
    >
      <button
        onClick={onClose}
        className="absolute top-4 right-4 text-gray-500 hover:text-red-500"
      >
        <X size={20} />
      </button>

      <div className="flex flex-col items-center text-center">
        <Trash2 className="text-red-600 mb-4" size={40} />
        <h2 className="text-xl font-semibold text-gray-800 mb-2">
          Delete User?
        </h2>
        <p className="text-gray-600 mb-6">
          Are you sure you want to delete{" "}
          <strong className="text-blue">{userName}</strong>? This action cannot
          be undone.
        </p>

        <div className="flex gap-4 w-full mx-4">
          <button
            onClick={onClose}
            className="px-4 w-1/2 py-2 rounded-lg bg-gray-200 hover:bg-gray-300 text-gray-700"
          >
            Cancel
          </button>
          <button
            onClick={onConfirm}
            disabled={isDeleting}
            className="px-4 py-2 w-1/2 rounded-lg bg-red hover:bg-red text-white flex items-center justify-center gap-2 disabled:opacity-60 disabled:cursor-not-allowed"
          >
            {isDeleting ? (
              <>
                <Loader className="animate-spin" size={18} />
                Deleting...
              </>
            ) : (
              "Delete"
            )}
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default DeleteUserModal;
